import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RegisterationAdminDecision, Languages, FormMode, ServiceStatus } from 'src/app/shared/models/enums.model';
import { RegistrationAdminDto } from '../../shared/models/registration-admin.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationAdminService } from '../../shared/services/registration-admin.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { UpdateAgentProfileComponent } from 'src/app/front-user/services/e-booking/update-agent-profile/update-agent-profile.component';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';

@Component({
  selector: 'app-register-admin-decision',
  templateUrl: './register-admin-decision.component.html',
  styleUrls: ['./register-admin-decision.component.css']
})
export class RegisterAdminDecisionComponent implements OnInit {

  @ViewChild('updateAgentRequest',{static: false}) updateAgentRequest: UpdateAgentProfileComponent;
  registerAdminForm: FormGroup;
  decision = RegisterationAdminDecision;
  decisionKeys = Object.keys(this.decision);
  displayedLang: string;
  baseRequestId: string = '';
  decisionValue: number;
  submitted = false;

  adminDecisionObject: RegistrationAdminDto = new RegistrationAdminDto();
  isReadOnly = true;
  agentId: string;
  error: any = { isError: false, errorMessage: '' };
  user: User = new User();
  baseRequestDTO: BaseRequest;
  showRequest = false;
  requestStatus: number;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  isErrorMessage: boolean = false;
  responseObj: ResponseObject = new ResponseObject();
  moreInformation: any;
  lockTaskErrorMessage: boolean = false;
  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices, private alertService: AlertService,
    private route: ActivatedRoute, private router: Router,
    private authenticationService: AuthenticationService,
    private adminSrv: RegistrationAdminService, private translate: TranslateService,
    private baseRequestService: BaseRequestService, private agentService: AgentService, ) {

    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';

    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    }else{
      window.history.back();
    }
    this.user = this.authenticationService.currentUserValue;

  }

  ngOnInit() {

    this.buildForm(null);
  }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        this.agentId = this.baseRequestDTO.RequestorId;
        this.baseRequestId = this.baseRequestDTO.Id;
        if (history.state.data && history.state.data.isCompleted) {
          this.getAgent(this.agentId, this.requestStatus);
        }
      }
    )
  }


  public getAgent(agentId: string, requestStatus) {
    this.agentService.GetAgent(agentId).subscribe(
      (resObj: ResponseObject) => {
        if (resObj.Success) {
          if (resObj.Data['MoreInformation'] && requestStatus != ServiceStatus.RequestIsDone) {
            this.decisionValue = RegisterationAdminDecision.MoreInformation;
            this.buildForm(this.decisionValue);
            this.registerAdminForm.patchValue({
              Decision: RegisterationAdminDecision.MoreInformation,
              MoreInformation: resObj.Data['MoreInformation']
            });
          }
          else {
            this.decisionValue = RegisterationAdminDecision.Approve;
            this.registerAdminForm.patchValue({
              Decision: RegisterationAdminDecision.Approve,
            });
          }
        }

        this.formMode = FormMode.Readonly;
        this.registerAdminForm.disable();
      });

  }

  buildForm(decision) {
    this.registerAdminForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });
    if (decision == RegisterationAdminDecision.MoreInformation) {
      this.registerAdminForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required]],
      });

    }
  }

  changeDecision(value) {
    this.buildForm(value);
    this.registerAdminForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
  }

  get f() {
    return this.registerAdminForm.controls;
  }


  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.registerAdminForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.adminDecisionObject = this.registerAdminForm.value;
    this.adminDecisionObject.AdminEmail = this.user.UserName;
    this.adminDecisionObject.RequestId = this.baseRequestId;
    this.adminDecisionObject.AgentId = this.agentId;
    if (this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.taxAuthorizationExpirationDate) {
      this.adminDecisionObject.taxAuthorizationExpirationDate = this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.taxAuthorizationExpirationDate.toLocaleString('en-US');
      this.adminDecisionObject.taxAuthorizationId = this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.taxAuthorizationId;

    }
    if (this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.taxCardAppendixExpirationDate) {
      this.adminDecisionObject.taxCardAppendixExpirationDate = this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.taxCardAppendixExpirationDate.toLocaleString('en-US');
      this.adminDecisionObject.taxCardAppendixId = this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.taxCardAppendixId;

    }
    if (this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.taxCardExpirationDate) {
      this.adminDecisionObject.taxCardExpirationDate = this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.taxCardExpirationDate.toLocaleString('en-US');
      this.adminDecisionObject.taxCardId = this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.taxCardId;

    }
    if (this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.shippingExpirationDate) {
      this.adminDecisionObject.shippingExpirationDate = this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.shippingExpirationDate.toLocaleString('en-US');
      this.adminDecisionObject.shippingId = this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.licensingsShippingId;

    }
    if (this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.otherDocumentsExpirationDate) {
      this.adminDecisionObject.otherDocumentsExpirationDate = this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.otherDocumentsExpirationDate.toLocaleString('en-US');
      this.adminDecisionObject.otherDocumentsId = this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.otherDocumentsId;

    }
    if (this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.commercialRecordExpirationDate) {
      this.adminDecisionObject.commercialRecordExpirationDate = this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.commercialRecordExpirationDate.toLocaleString('en-US');
      this.adminDecisionObject.commercialRecordId = this.updateAgentRequest.updateAgentForm.controls.agentCertificate.value.commercialRecordId;
    }
    this.adminSrv.AdminDecisionAgentProfile(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.registerAdminForm.reset();
            this.showRequest = true;
            this.isErrorMessage = false;
          } else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]), false);

          }

        });
  }

}
